(function () {
  if (window.__ptSearch) return;
  window.__ptSearch = 1;

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function rs(n) { return '\u20b9' + Math.round(n).toLocaleString('en-IN'); }
  function sized(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; }

  function init() {
    var panel = document.getElementById('pt-search');
    if (!panel) return;
    var input = panel.querySelector('input[type=search]');
    if (!input) return;

    var box = document.createElement('div');
    box.className = 'pts';
    box.id = 'pt-search-results';
    box.setAttribute('aria-live', 'polite');
    panel.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('enterkeyhint', 'search');

    var timer = null, ctl = null, last = '';

    function fit() {
      var vv = window.visualViewport, h = vv ? vv.height : window.innerHeight;
      var top = box.getBoundingClientRect().top;
      box.style.maxHeight = Math.max(150, h - top - 12) + 'px';
    }
    function hide() { box.classList.remove('is-on'); box.innerHTML = ''; last = ''; }
    function show(html) { box.innerHTML = html; box.classList.add('is-on'); fit(); }

    function row(p) {
      var img = p.image || (p.featured_image && p.featured_image.url) || '';
      var price = parseFloat(p.price), cmp = parseFloat(p.compare_at_price_max || 0);
      var priceHtml = isNaN(price) ? '' : rs(price) + (cmp > price ? '<s>' + rs(cmp) + '</s>' : '');
      var sold = p.available === false ? (priceHtml ? ' &middot; ' : '') + 'Sold out' : '';
      return `<a class='pts__row' href='${p.url}'><span class='pts__img'>${img ? `<img src='${sized(img)}' alt='' loading='lazy' width='120' height='120'>` : ''}</span><span class='pts__info'><b>${esc(p.title)}</b><small>${priceHtml}${sold}</small></span></a>`;
    }

    function run(q) {
      if (q === last) return;
      last = q;
      if (ctl) ctl.abort();
      ctl = ('AbortController' in window) ? new AbortController() : null;
      show(`<p class='pts__msg'>Searching...</p>`);
      var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      var url = base + '.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url, ctl ? { signal: ctl.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!items.length) {
            show(`<p class='pts__msg'>No plants found for &ldquo;${esc(q)}&rdquo;. Try another name, or <a href='https://wa.me/917600760639' target='_blank' rel='noopener'>ask us on WhatsApp</a>.</p>`);
            return;
          }
          show(items.map(row).join('') + `<a class='pts__all' href='/search?q=${encodeURIComponent(q)}&type=product'>See all results for &ldquo;${esc(q)}&rdquo;</a>`);
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          show(`<p class='pts__msg'>Could not load results. Press search to see all plants.</p>`);
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { if (ctl) ctl.abort(); hide(); return; }
      timer = setTimeout(function () { run(q); }, 220);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { if (box.classList.contains('is-on')) fit(); });
    if ('MutationObserver' in window) new MutationObserver(function () { if (panel.hasAttribute('hidden')) hide(); }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
